// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_right {
    padding-top: 18px;
    width: 100%;
    padding-right: 30px;
    padding-bottom: 40px;
    padding-left: 30px;
}

/* Profile shell: sidebar is position:fixed — reserve width so content does not sit underneath it. */
.dashboard>.dashboard_right {
    flex: 1 1;
    min-width: 0;
    width: auto;
    max-width: 100%;
}

.Overview_mid {
    flex-direction: column;
}

.listing_left_outer.full_width {
    width: 100%;
    border: 1px solid #434343;
    border-radius: 12px;
    padding: 24px;
}

.listing_left_outer.full_width.transaction_history_t {
    margin-top: 15px;
    padding-top: 0px;
}

.listing_left_outer h4 {
    font-size: 24px;
    font-weight: 600;
    margin: 0px;
}

.full_width.transaction_history_t {
    border: none;
    padding: 12px 0px;
}

.dashboard_listing_section.Overview_mid {
    padding-left: 20px;
    margin-top: 0px;
}

.dashboard_right .dashboard_listing_section.Overview_mid {
    padding-left: 0px;
    padding-right: 0px;
}

.desktop_view2 {
    display: block;
}

.order_history_mobile_view {
    width: 100%;
    display: none;
    margin-top: 20px;
}

@media screen and (max-width: 1367px) {
    .desktop_view2 {
        display: none;
    }

    .order_history_mobile_view {
        display: block;
    }
}


/* ========== PAGE LAYOUT ========== */

.market_section.spotorderhist {
    padding: 20px;
    border: 1.5px solid #2B313C;
    /* background-color: #373E4B; */
    border-radius: 12px;
}

.transaction_history_t .spotorderhist .top_heading {
    margin: 0px;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 18px;
}

.top_heading {
    display: flex;
    margin-bottom: 6px;
    justify-content: center;
    align-items: center;
}

.coin_right {
    display: flex;
    align-items: center;
    gap: 24px;
}

.market_section .coin_right {
    padding: 0px;
}

.market_section .dashboard_summary.quickbuysell th {
    font-size: 12px;
}


/* ========== SEARCH ========== */

.searchBar.custom-tabs {
    background-color: #1f1f1f;
    border: 1px solid #787878;
    padding: 7px 10px;
    font-size: 12px;
    border-radius: 50px;
    gap: 3px;
}

.searchBar.custom-tabs {
    padding: 6px 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    background-color: #2B313C;
    border: none;
    font-size: 16px;
    font-weight: 400;
    border-radius: 4px;
    width: 40px;
    transition: 0.5s all;
    overflow: hidden;
}

.searchBar button {
    width: 18px;
    opacity: 0.7;
    background-color: transparent;
    border: transparent;
    padding: 0px;
}

.searchBar button i {
    font-size: 16px;
    color: #fff !important;
    opacity: 1;
}

.searchBar.custom-tabs input {
    font-size: 14px;
    font-weight: 300;
    padding: 0px 10px;
    background: transparent;
    border: 0 !important;
    min-width: min-content;
    width: 100%;
}

.searchBar.custom-tabs input {
    outline: 0;
}

.searchBar.custom-tabs i {
    cursor: pointer;
}

.searchBar.custom-tabs.search_active {
    width: 320px;
    padding-left: 10px;
}

.searchBar .custom_search {
    display: none;
}

.searchBar.custom-tabs.search_active .custom_search {
    display: block;
}


/* ========== TABLE ========== */

.dashboard_summary.quickbuysell .right_td {
    text-align: right;
}

.dashboard_summary.quickbuysell tbody tr {
    transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

.dashboard_summary.quickbuysell tbody tr:hover {
    box-shadow: 0px 0px 20px #f3ba2b14;
    background-color: rgb(54 54 54 / 11%);
}

.dashboard_summary.quickbuysell table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
    color: white;
}

.dashboard_summary.quickbuysell th {
    text-align: left;
}

.dashboard_summary.quickbuysell td {
    font-size: 15px;
    font-weight: 400;
    color: #EAECEF;
    padding: 14px 5px;
}

.dashboard_summary.quickbuysell th {
    padding: 5px;
    white-space: nowrap;
    border: none;
    font-size: 11px;
    color: #848E9C;
    font-weight: 500;
}

.transaction_history_t .quickbuysell table tr:hover {
    background-color: #ffffff12;
}

.transaction_history_t .quickbuysell table tr td {
    padding: 7px 12px;
}

.transaction_history_t .quickbuysell table tr th {
    padding: 7px 12px;
}

.transaction_history_t .quickbuysell .top_heading {
    margin: 0px;
}

.transaction_history_t .dashboard_summary.quickbuysell .market_section .dashboard_summary.quickbuysell table {
    margin-top: 0px;
    height: 100%;
}


/* ========== PAGINATION ========== */

.hVPalX.gap-2 {
    padding: 24px 0px 0px;
    text-align: end;
}

button.sc-gjLLEI.kuPCgf {
    background-color: transparent;
    border: none;
}

.hVPalX.gap-2 span {
    margin-top: 5px;
    font-size: 14px;
    padding-left: 4px;
}

button.sc-gjLLEI.kuPCgf svg>path {
    stroke: #D1AA67;
}

.sc-eAKtBH.gVtWSU {
    display: flex;
    gap: 15px;
    justify-content: end;
}

.hVPalX.gap-2 {
    text-align: end;
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 15px !important;
}

.hVPalX.gap-2 span {
    margin-top: 0px;
    color: #bababc;
}

.sc-eAKtBH.gVtWSU button {
    padding: 4px 0px;
}


/* ========== MOBILE CARDS ========== */

.order_datalist {
    width: 100%;
    padding: 0px 0px 14px;
    border-bottom: 1.5px solid rgb(43 49 60);
    border-radius: 5px;
}

.order_datalist .listdata {
    display: flex;
    flex-direction: column;
    gap: 10px;
    /* border-bottom: 1px solid #ffffff9c; */
    padding-bottom: 5px;
}

.order_datalist_2 .listdata {
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-bottom: none;
    padding-bottom: 0px;
}

.order_datalist .listdata li {
    display: flex;
    flex-direction: row;
    gap: 15px;
    font-size: 12px;
    font-weight: 300;
    color: #ffffff;
}

.order_datalist .listdata li span.date {
    color: #fff !important;
    font-size: 14px;
    margin: 0px;
}

.order_history_mobile_view .d-flex {
    flex-direction: column;
    gap: 15px;
}

.order_datalist .listdata li span.date_light {
    color: #ffffffa3 !important;
    margin: 0px;
}

button.view_more_btn {
    background-color: transparent;
    color: #9fa0a2;
    border: none;
    padding: 0px;
    text-align: start;
    width: 100%;
    margin-top: -22px;
    font-weight: 400;
    font-size: 20px;
    transform: rotate(180deg);
}

.order_datalist .listdata li span:first-child {
    color: #ffffffa3;
    width: 50%;
    text-align: left;
}

.order_datalist .listdata li span:last-child {
    width: 50%;
    text-align: right;
}


/* ========== ORDERS SUB TABS (spotOrders.css) ========== */

.so-subtabsWrap {
    position: relative;
}

.so-subtabs {
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 10px 0 0;
    margin: 0 0 14px;
    border-bottom: none;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
}

.so-subtabs::-webkit-scrollbar {
    display: none;
}

.so-subtabs__tab {
    position: relative;
    padding: 10px 0 7px;
    font-size: 16px;
    font-weight: 500;
    color: #667085;
    text-decoration: none;
    white-space: nowrap;
}

.so-subtabs__tab:hover {
    color: #f1f1f1;
}

body.light_theme .so-subtabs__tab:hover {
    color: #101828;
}

.so-subtabs__tab.is-active {
    color: #f1f1f1;
}

body.light_theme .so-subtabs__tab.is-active {
    color: #101828;
}

.so-subtabs__tab.is-active::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -1px;
    right: 0px;
    width: 18px;
    height: 4px;
    background: #d1aa67;
    border-radius: 0px;
    margin: 0 auto;
}

/* Subtabs scroll arrows (mobile only) */
.so-subtabsArrow {
    display: none;
}


/* ========== LIGHT THEME ========== */

body.light_theme .dashboard_right {
    background-color: #fff;
    color: #101828;
}

body.light_theme .dashboard_right .market_section .top_heading h4 {
    color: #101828;
}

body.light_theme .dashboard_right .top_heading h4 {
    color: #101828;
}

body.light_theme .dashboard_right .dashboard_summary.quickbuysell.quickbuysell {
    color: #333;
}

body.light_theme .dashboard_right .dashboard_summary.quickbuysell td {
    color: #0f0f0f;
}

body.light_theme .searchBar.custom-tabs {
    background-color: #fff;
}

body.light_theme .searchBar.custom-tabs i {
    color: #000;
}

body.light_theme .searchBar.custom-tabs input {
    color: #000;
}

body.light_theme .order_datalist .listdata li {
    color: #191919;
}

body.light_theme .order_datalist .listdata li span:first-child {
    color: #000000;
}

body.light_theme .order_datalist .listdata li span.date {
    color: #000000 !important;
}

body.light_theme .order_datalist .listdata li span.date_light {
    color: #000000db !important;
}


/* ========== RESPONSIVE ========== */

@media screen and (max-width:1200px) {

    .top_heading h4 {
        font-size: 18px;
    }

}

@media screen and (max-width:991px) {

    .transaction_history_t table tr td {
        padding: 10px 7px !important;
    }

    .transaction_history_t table tr th {
        padding: 10px 7px !important;
    }

}

@media screen and (max-width:767px) {

    .listing_left_outer.full_width.transaction_history_t .market_section.spotorderhist {
        padding-top: 20px;
    }

    .market_section.spotorderhist {
        padding-top: 0px;
    }

}

@media screen and (max-width:660px) {

    .transaction_history_t .spotorderhist .top_heading {
        flex-direction: column;
        gap: 5px;
        margin-bottom: 0px;
    }

}

@media screen and (max-width:414px) {

    .Overview_mid .top_heading h4 {
        margin-bottom: 10px;
    }

}

@media (max-width: 991.98px) {

    .order_datalist {
        border-bottom: none;
        border-radius: 0px;
    }

    .order_datalist .listdata li span.date {
        font-size: 15px;
        font-weight: 400;
    }

    .order_datalist .listdata li {
        font-size: 15px;
        font-weight: 400;
    }

    .order_history_mobile_view .d-flex.coin_right h5 {
        display: none;
    }

    .Overview_mid .searchBar.custom-tabs {
        padding: 0px;
    }

    .Overview_mid .market_section .searchBar.custom-tabs {
        padding: 5px;
    }

    .order_history_mobile_view .coin_right .d-flex {
        gap: 1px !important;
        align-items: center !important;
        margin-bottom: 0px !important;
    }

    .searchBar.custom-tabs {
        font-size: 18px;
    }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/QuickBuySellHistory/QuickBuySellHistory.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA,oGAAoG;AACpG;IACI,SAAY;IACZ,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ;;;AAGA,sCAAsC;;AAEtC;IACI,aAAa;IACb,2BAA2B;IAC3B,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;;AAGA,iCAAiC;;AAEjC;IACI,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,oBAAoB;IACpB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;;AAGA,gCAAgC;;AAEhC;IACI,iBAAiB;AACrB;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;;AAGA,qCAAqC;;AAErC;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA,uCAAuC;;AAEvC;IACI,WAAW;IACX,qBAAqB;IACrB,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;;AAGA,2DAA2D;;AAE3D;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,UAAU;IACV,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA,wCAAwC;AACxC;IACI,aAAa;AACjB;;;AAGA,sCAAsC;;AAEtC;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA,qCAAqC;;AAErC;;IAEI;QACI,eAAe;IACnB;;AAEJ;;AAEA;;IAEI;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;AAEJ;;AAEA;;IAEI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;AAEJ;;AAEA;;IAEI;QACI,sBAAsB;QACtB,QAAQ;QACR,kBAAkB;IACtB;;AAEJ;;AAEA;;IAEI;QACI,mBAAmB;IACvB;;AAEJ;;AAEA;;IAEI;QACI,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,8BAA8B;QAC9B,6BAA6B;IACjC;;IAEA;QACI,eAAe;IACnB;;AAEJ","sourcesContent":[".dashboard_right {\n    padding-top: 18px;\n    width: 100%;\n    padding-right: 30px;\n    padding-bottom: 40px;\n    padding-left: 30px;\n}\n\n/* Profile shell: sidebar is position:fixed — reserve width so content does not sit underneath it. */\n.dashboard>.dashboard_right {\n    flex: 1 1 0%;\n    min-width: 0;\n    width: auto;\n    max-width: 100%;\n}\n\n.Overview_mid {\n    flex-direction: column;\n}\n\n.listing_left_outer.full_width {\n    width: 100%;\n    border: 1px solid #434343;\n    border-radius: 12px;\n    padding: 24px;\n}\n\n.listing_left_outer.full_width.transaction_history_t {\n    margin-top: 15px;\n    padding-top: 0px;\n}\n\n.listing_left_outer h4 {\n    font-size: 24px;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.full_width.transaction_history_t {\n    border: none;\n    padding: 12px 0px;\n}\n\n.dashboard_listing_section.Overview_mid {\n    padding-left: 20px;\n    margin-top: 0px;\n}\n\n.dashboard_right .dashboard_listing_section.Overview_mid {\n    padding-left: 0px;\n    padding-right: 0px;\n}\n\n.desktop_view2 {\n    display: block;\n}\n\n.order_history_mobile_view {\n    width: 100%;\n    display: none;\n    margin-top: 20px;\n}\n\n@media screen and (max-width: 1367px) {\n    .desktop_view2 {\n        display: none;\n    }\n\n    .order_history_mobile_view {\n        display: block;\n    }\n}\n\n\n/* ========== PAGE LAYOUT ========== */\n\n.market_section.spotorderhist {\n    padding: 20px;\n    border: 1.5px solid #2B313C;\n    /* background-color: #373E4B; */\n    border-radius: 12px;\n}\n\n.transaction_history_t .spotorderhist .top_heading {\n    margin: 0px;\n    justify-content: space-between;\n    gap: 20px;\n    margin-bottom: 18px;\n}\n\n.top_heading {\n    display: flex;\n    margin-bottom: 6px;\n    justify-content: center;\n    align-items: center;\n}\n\n.coin_right {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n}\n\n.market_section .coin_right {\n    padding: 0px;\n}\n\n.market_section .dashboard_summary.quickbuysell th {\n    font-size: 12px;\n}\n\n\n/* ========== SEARCH ========== */\n\n.searchBar.custom-tabs {\n    background-color: #1f1f1f;\n    border: 1px solid #787878;\n    padding: 7px 10px;\n    font-size: 12px;\n    border-radius: 50px;\n    gap: 3px;\n}\n\n.searchBar.custom-tabs {\n    padding: 6px 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    background-color: #2B313C;\n    border: none;\n    font-size: 16px;\n    font-weight: 400;\n    border-radius: 4px;\n    width: 40px;\n    transition: 0.5s all;\n    overflow: hidden;\n}\n\n.searchBar button {\n    width: 18px;\n    opacity: 0.7;\n    background-color: transparent;\n    border: transparent;\n    padding: 0px;\n}\n\n.searchBar button i {\n    font-size: 16px;\n    color: #fff !important;\n    opacity: 1;\n}\n\n.searchBar.custom-tabs input {\n    font-size: 14px;\n    font-weight: 300;\n    padding: 0px 10px;\n    background: transparent;\n    border: 0 !important;\n    min-width: min-content;\n    width: 100%;\n}\n\n.searchBar.custom-tabs input {\n    outline: 0;\n}\n\n.searchBar.custom-tabs i {\n    cursor: pointer;\n}\n\n.searchBar.custom-tabs.search_active {\n    width: 320px;\n    padding-left: 10px;\n}\n\n.searchBar .custom_search {\n    display: none;\n}\n\n.searchBar.custom-tabs.search_active .custom_search {\n    display: block;\n}\n\n\n/* ========== TABLE ========== */\n\n.dashboard_summary.quickbuysell .right_td {\n    text-align: right;\n}\n\n.dashboard_summary.quickbuysell tbody tr {\n    transition: background-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.dashboard_summary.quickbuysell tbody tr:hover {\n    box-shadow: 0px 0px 20px #f3ba2b14;\n    background-color: rgb(54 54 54 / 11%);\n}\n\n.dashboard_summary.quickbuysell table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n    color: white;\n}\n\n.dashboard_summary.quickbuysell th {\n    text-align: left;\n}\n\n.dashboard_summary.quickbuysell td {\n    font-size: 15px;\n    font-weight: 400;\n    color: #EAECEF;\n    padding: 14px 5px;\n}\n\n.dashboard_summary.quickbuysell th {\n    padding: 5px;\n    white-space: nowrap;\n    border: none;\n    font-size: 11px;\n    color: #848E9C;\n    font-weight: 500;\n}\n\n.transaction_history_t .quickbuysell table tr:hover {\n    background-color: #ffffff12;\n}\n\n.transaction_history_t .quickbuysell table tr td {\n    padding: 7px 12px;\n}\n\n.transaction_history_t .quickbuysell table tr th {\n    padding: 7px 12px;\n}\n\n.transaction_history_t .quickbuysell .top_heading {\n    margin: 0px;\n}\n\n.transaction_history_t .dashboard_summary.quickbuysell .market_section .dashboard_summary.quickbuysell table {\n    margin-top: 0px;\n    height: 100%;\n}\n\n\n/* ========== PAGINATION ========== */\n\n.hVPalX.gap-2 {\n    padding: 24px 0px 0px;\n    text-align: end;\n}\n\nbutton.sc-gjLLEI.kuPCgf {\n    background-color: transparent;\n    border: none;\n}\n\n.hVPalX.gap-2 span {\n    margin-top: 5px;\n    font-size: 14px;\n    padding-left: 4px;\n}\n\nbutton.sc-gjLLEI.kuPCgf svg>path {\n    stroke: #D1AA67;\n}\n\n.sc-eAKtBH.gVtWSU {\n    display: flex;\n    gap: 15px;\n    justify-content: end;\n}\n\n.hVPalX.gap-2 {\n    text-align: end;\n    display: flex;\n    justify-content: end;\n    align-items: center;\n    gap: 15px !important;\n}\n\n.hVPalX.gap-2 span {\n    margin-top: 0px;\n    color: #bababc;\n}\n\n.sc-eAKtBH.gVtWSU button {\n    padding: 4px 0px;\n}\n\n\n/* ========== MOBILE CARDS ========== */\n\n.order_datalist {\n    width: 100%;\n    padding: 0px 0px 14px;\n    border-bottom: 1.5px solid rgb(43 49 60);\n    border-radius: 5px;\n}\n\n.order_datalist .listdata {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    /* border-bottom: 1px solid #ffffff9c; */\n    padding-bottom: 5px;\n}\n\n.order_datalist_2 .listdata {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    border-bottom: none;\n    padding-bottom: 0px;\n}\n\n.order_datalist .listdata li {\n    display: flex;\n    flex-direction: row;\n    gap: 15px;\n    font-size: 12px;\n    font-weight: 300;\n    color: #ffffff;\n}\n\n.order_datalist .listdata li span.date {\n    color: #fff !important;\n    font-size: 14px;\n    margin: 0px;\n}\n\n.order_history_mobile_view .d-flex {\n    flex-direction: column;\n    gap: 15px;\n}\n\n.order_datalist .listdata li span.date_light {\n    color: #ffffffa3 !important;\n    margin: 0px;\n}\n\nbutton.view_more_btn {\n    background-color: transparent;\n    color: #9fa0a2;\n    border: none;\n    padding: 0px;\n    text-align: start;\n    width: 100%;\n    margin-top: -22px;\n    font-weight: 400;\n    font-size: 20px;\n    transform: rotate(180deg);\n}\n\n.order_datalist .listdata li span:first-child {\n    color: #ffffffa3;\n    width: 50%;\n    text-align: left;\n}\n\n.order_datalist .listdata li span:last-child {\n    width: 50%;\n    text-align: right;\n}\n\n\n/* ========== ORDERS SUB TABS (spotOrders.css) ========== */\n\n.so-subtabsWrap {\n    position: relative;\n}\n\n.so-subtabs {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    padding: 10px 0 0;\n    margin: 0 0 14px;\n    border-bottom: none;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n}\n\n.so-subtabs::-webkit-scrollbar {\n    display: none;\n}\n\n.so-subtabs__tab {\n    position: relative;\n    padding: 10px 0 7px;\n    font-size: 16px;\n    font-weight: 500;\n    color: #667085;\n    text-decoration: none;\n    white-space: nowrap;\n}\n\n.so-subtabs__tab:hover {\n    color: #f1f1f1;\n}\n\nbody.light_theme .so-subtabs__tab:hover {\n    color: #101828;\n}\n\n.so-subtabs__tab.is-active {\n    color: #f1f1f1;\n}\n\nbody.light_theme .so-subtabs__tab.is-active {\n    color: #101828;\n}\n\n.so-subtabs__tab.is-active::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    bottom: -1px;\n    right: 0px;\n    width: 18px;\n    height: 4px;\n    background: #d1aa67;\n    border-radius: 0px;\n    margin: 0 auto;\n}\n\n/* Subtabs scroll arrows (mobile only) */\n.so-subtabsArrow {\n    display: none;\n}\n\n\n/* ========== LIGHT THEME ========== */\n\nbody.light_theme .dashboard_right {\n    background-color: #fff;\n    color: #101828;\n}\n\nbody.light_theme .dashboard_right .market_section .top_heading h4 {\n    color: #101828;\n}\n\nbody.light_theme .dashboard_right .top_heading h4 {\n    color: #101828;\n}\n\nbody.light_theme .dashboard_right .dashboard_summary.quickbuysell.quickbuysell {\n    color: #333;\n}\n\nbody.light_theme .dashboard_right .dashboard_summary.quickbuysell td {\n    color: #0f0f0f;\n}\n\nbody.light_theme .searchBar.custom-tabs {\n    background-color: #fff;\n}\n\nbody.light_theme .searchBar.custom-tabs i {\n    color: #000;\n}\n\nbody.light_theme .searchBar.custom-tabs input {\n    color: #000;\n}\n\nbody.light_theme .order_datalist .listdata li {\n    color: #191919;\n}\n\nbody.light_theme .order_datalist .listdata li span:first-child {\n    color: #000000;\n}\n\nbody.light_theme .order_datalist .listdata li span.date {\n    color: #000000 !important;\n}\n\nbody.light_theme .order_datalist .listdata li span.date_light {\n    color: #000000db !important;\n}\n\n\n/* ========== RESPONSIVE ========== */\n\n@media screen and (max-width:1200px) {\n\n    .top_heading h4 {\n        font-size: 18px;\n    }\n\n}\n\n@media screen and (max-width:991px) {\n\n    .transaction_history_t table tr td {\n        padding: 10px 7px !important;\n    }\n\n    .transaction_history_t table tr th {\n        padding: 10px 7px !important;\n    }\n\n}\n\n@media screen and (max-width:767px) {\n\n    .listing_left_outer.full_width.transaction_history_t .market_section.spotorderhist {\n        padding-top: 20px;\n    }\n\n    .market_section.spotorderhist {\n        padding-top: 0px;\n    }\n\n}\n\n@media screen and (max-width:660px) {\n\n    .transaction_history_t .spotorderhist .top_heading {\n        flex-direction: column;\n        gap: 5px;\n        margin-bottom: 0px;\n    }\n\n}\n\n@media screen and (max-width:414px) {\n\n    .Overview_mid .top_heading h4 {\n        margin-bottom: 10px;\n    }\n\n}\n\n@media (max-width: 991.98px) {\n\n    .order_datalist {\n        border-bottom: none;\n        border-radius: 0px;\n    }\n\n    .order_datalist .listdata li span.date {\n        font-size: 15px;\n        font-weight: 400;\n    }\n\n    .order_datalist .listdata li {\n        font-size: 15px;\n        font-weight: 400;\n    }\n\n    .order_history_mobile_view .d-flex.coin_right h5 {\n        display: none;\n    }\n\n    .Overview_mid .searchBar.custom-tabs {\n        padding: 0px;\n    }\n\n    .Overview_mid .market_section .searchBar.custom-tabs {\n        padding: 5px;\n    }\n\n    .order_history_mobile_view .coin_right .d-flex {\n        gap: 1px !important;\n        align-items: center !important;\n        margin-bottom: 0px !important;\n    }\n\n    .searchBar.custom-tabs {\n        font-size: 18px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
